// Old policy URLs (spec 3, "redirects for a release"). Each line names the
// product it belongs to; the redirect is live once that product's adapter is
// (products/<key> exports one), and until then the old screen still renders.
// So phase 2 adds no logic here: a new legacy URL is one more line.
import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

import { hasAdapter } from "./productRegistry";
import { policiesPath, productForMode } from "./policyProducts";

// from: the old route (documentation and lookup key); to(params) -> new path.
export const LEGACY_POLICY_ROUTES = [
  { from: "/pam/policy/v2/create", product: "ad", to: () => policiesPath("ad", "new") },
  { from: "/pam/policy/v2/edit/:policyId", product: "ad", to: ({ policyId }) => policiesPath("ad", `${policyId}/edit`) },
  { from: "/pam/policy/v2/createRadiusPolicy", product: "radius", to: () => policiesPath("radius", "new") },
  { from: "/pam/policy/v2/createPolicy", product: "database", to: () => policiesPath("database", "new") },
  { from: "/pam/applications/policies", product: "apps", to: () => policiesPath("apps") },
  { from: "/pam/applications/policies/new", product: "apps", to: () => policiesPath("apps", "new") },
  { from: "/pam/applications/policies/:policyId", product: "apps", to: ({ policyId }) => policiesPath("apps", policyId) },
];

export const legacyRouteFor = (from) => LEGACY_POLICY_ROUTES.find((r) => r.from === from) || null;

/** Redirects `from`'s URL to its new home when the product is live; else renders children (the old screen). */
export function LegacyPolicyRedirect({ from, children }) {
  const params = useParams();
  const { search } = useLocation();
  const route = legacyRouteFor(from);
  if (route && hasAdapter(route.product)) return <Navigate to={`${route.to(params)}${search}`} replace />;
  return children;
}

/** Route element helper for pamRouter: legacyPolicyElement(from, <OldScreen />). */
export const legacyPolicyElement = (from, element) => <LegacyPolicyRedirect from={from}>{element}</LegacyPolicyRedirect>;

/** /pam/policy/v2: the current product's policies. */
export function PoliciesIndexRedirect() {
  const { search } = useLocation();
  let mode = null;
  try {
    mode = window.localStorage.getItem("currentMode");
  } catch {
    mode = null;
  }
  const product = productForMode(mode) || "ad";
  return <Navigate to={`${policiesPath(product)}${search}`} replace />;
}
